import { googleAuthContext } from '../../utils/social/googleAuthContext'; // Флаг, который указывает - инициализирован ли на странице скрипт для
// взаимодействия с Google API

var loaded = false;
export default (function (clientId) {
  if (loaded) {
    return;
  }

  loaded = true;

  window.onGoogleLibraryLoad = function () {
    return googleAuthContext.initGoogleAuth(clientId, ['profile']);
  };
});